import { Divider } from "antd";
import Header from "./Desktop/Header";
import SearchBar from "./Desktop/SearchBar";
import Container from "./Desktop/Container";
import Footer from "./Desktop/Footer";
import { useMediaQuery } from "react-responsive";
import MobileContainer from "./Mobile/Container";
import MobileHeader from "./Mobile/Header";
import MobileFooter from "./Mobile/Footer";
import { IS_BREAKPOINT_DESKTOP } from "constants/common";
import useFitScale from "hooks/useFitScale";

interface INarinLayout {
  children: React.ReactNode;
}

const NarinLayout = ({ children }: INarinLayout) => {
  const isDesktop = useMediaQuery({
    query: IS_BREAKPOINT_DESKTOP,
  });
  const scale = useFitScale();

  if (isDesktop) {
    return (
      <div style={{ zoom: scale }}>
        <Container>
          <Header />
        </Container>
        <Divider className="my-0" />
        <Container>
          <SearchBar />
        </Container>

        <Container>
          <main className="min-h-[700px] bg-[#F7F4FA]">{children}</main>
        </Container>

        <footer>
          <Footer />
        </footer>
      </div>
    );
  }

  return (
    <div>
      <MobileContainer>
        <MobileHeader />
        <main className="min-h-[700px] bg-[#F7F4FA]">{children}</main>
      </MobileContainer>

      <footer>
        <MobileFooter />
      </footer>
    </div>
  );
};
export default NarinLayout;
